var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Adapted from: https://github.com/umdjs/umd/blob/master/templates/returnExports.js
(function (factory) {
    if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        module.exports = factory(require('prop-types'), require('../lazy-gettext/GenericLazyString'));
    } else if (typeof define === 'function' && define.amd) {
        // NOTE: requirejs isn't able to follow relative dependencies in AMD so we're using this
        // "absolute" path. It's defined in the require_base_config.js file in core to point to the
        // LazyString.js file w/in this module. It's a pretty nasty co-dependency, but hopefully
        // a very temporary one for when we can move off of requirejs
        define(['react', 'js-utils/lazy-gettext/GenericLazyString'], function (React, GenericLazyString) {
            return factory(React.PropTypes, GenericLazyString);
        });
    }
})(function (PropTypes, GenericLazyString) {
    return {
        // We defer to using custom prop type function instead of oneOfType
        // because PropTypes.instanceOf(String) doesn't work with lazyString, which doesn't
        // directly inherit from String class, which is available in ES6
        translation: PropTypes.oneOfType([PropTypes.string, function (props, propName, componentName) {
            if (props[propName]) {
                if (!GenericLazyString.isValid(props[propName])) {
                    return new Error('Invalid prop `' + propName + '` supplied to' + (' `' + componentName + '`. Expected a GenericLazyString object.'));
                }
            }

            return null;
        }])
    };
});